var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "project-modal edit-deliverable-modal edit-project-modal",
      class: !_vm.userCanEditProject ? "read-only" : "",
      attrs: { id: "edit__project__modal" }
    },
    [
      _c("div", { staticClass: "project--top--section" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-md-8 d-flex left--side" },
            [
              _c("div", { staticClass: "project--page--title" }, [
                _c("h2", { staticClass: "d-inline-block" }, [
                  _c(
                    "div",
                    {
                      staticClass: "project-icon bigger-icon pointer-default",
                      style: {
                        backgroundColor: _vm.getProjectColor(_vm.projectDetail)
                      }
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: require("@/csmworkflow/img/white-folder.svg")
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "text--section" }, [
                  _c(
                    "div",
                    { staticClass: "project--department--wrap" },
                    [
                      _c("ProjectDepartments", {
                        attrs: { deliverable: _vm.projectDetail }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("label", { staticClass: "mb-0 w-100" }, [
                    _c(
                      "h1",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.editTitle,
                            expression: "!editTitle"
                          }
                        ],
                        staticClass:
                          "mb-0 exclude-outside-click edit-d-title project-title",
                        staticStyle: { "line-height": "1" },
                        on: { click: _vm.activateTitleField }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.projectDetail.title || "Click to set...")
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("textarea", {
                      directives: [
                        {
                          name: "click-outside",
                          rawName: "v-click-outside",
                          value: _vm.outside,
                          expression: "outside"
                        },
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.editTitle,
                          expression: "editTitle"
                        },
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.projectDetail.title,
                          expression: "projectDetail.title"
                        }
                      ],
                      ref: "deliverableTitle",
                      staticClass:
                        "form-control mb-3 title-field exclude-outside-click h1",
                      attrs: { type: "text", placeholder: "Project title..." },
                      domProps: { value: _vm.projectDetail.title },
                      on: {
                        change: _vm.updateProjectTitle,
                        blur: function($event) {
                          _vm.editTitle = false
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.projectDetail,
                            "title",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "project-number" }, [
                    _c("span", [
                      _vm._v(
                        "Project Number: " +
                          _vm._s(_vm.projectDetail.project_number)
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "project-due-date" }, [
                    _vm._v("\n              Deadline:\n              "),
                    _c(
                      "span",
                      {
                        ref: "refDatepickerWrapper",
                        staticClass: "editable-project-due-date",
                        on: { click: _vm.projectDueDateClick }
                      },
                      [
                        _c("div", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.editProjectDueDateBg,
                              expression: "editProjectDueDateBg"
                            }
                          ],
                          staticClass: "custom-field-outside-bg-mobile"
                        }),
                        _vm._v(" "),
                        _c(
                          "vuejs-datepicker",
                          {
                            directives: [
                              {
                                name: "field-dismiss",
                                rawName: "v-field-dismiss",
                                value: _vm.editProjectDatePickerClickOutside,
                                expression: "editProjectDatePickerClickOutside"
                              }
                            ],
                            ref: "projectDueDate",
                            attrs: { placeholder: "No Date" },
                            on: {
                              input: _vm.updateProjectDueDate,
                              selected: _vm.projectDueDateSelected
                            },
                            nativeOn: {
                              focusin: function($event) {
                                return _vm.findPosition.apply(null, arguments)
                              }
                            },
                            model: {
                              value: _vm.projectDetail.due_date,
                              callback: function($$v) {
                                _vm.$set(_vm.projectDetail, "due_date", $$v)
                              },
                              expression: "projectDetail.due_date"
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "calender-header",
                                attrs: { slot: "beforeCalendarHeader" },
                                slot: "beforeCalendarHeader"
                              },
                              [
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "remove-dl-btn",
                                    attrs: { variant: "text" },
                                    on: { click: _vm.resetDeadline }
                                  },
                                  [_vm._v("Remove Deadline")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "today-btn",
                                    attrs: { variant: "text" },
                                    on: { click: _vm.onToday }
                                  },
                                  [_vm._v("Today")]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _vm.projectDeliverables.length
                ? _c("div", { staticClass: "project--milestones" }, [
                    _c("label", { staticClass: "field-label" }, [
                      _vm._v("PROJECT MILESTONES")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "project--milestones-wrap" },
                      _vm._l(_vm.projectDeliverables.length, function(index) {
                        return _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip",
                                value: {
                                  customClass: "milestone--tooltip",
                                  html: true,
                                  title: _vm.tipData(
                                    _vm.projectDeliverables[index - 1]
                                  ),
                                  trigger: "hover"
                                },
                                expression:
                                  "{ customClass: 'milestone--tooltip', html: true, title: tipData(projectDeliverables[index - 1]), trigger: 'hover' }"
                              }
                            ],
                            staticClass: "milestone",
                            class: {
                              active:
                                _vm.projectDeliverables[index - 1]
                                  .is_complete == 1,
                              dots: index <= _vm.projectDeliverables.length
                            }
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "milestone--full--deliverable" },
                              [_vm._v(" ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "milestone--task--expanson" },
                              _vm._l(
                                _vm.projectDeliverables[index - 1].tasks.length,
                                function(index1) {
                                  return _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip",
                                          value: {
                                            customClass: "milestone--tooltip",
                                            html: true,
                                            title: _vm.tipTaskData(
                                              _vm.projectDeliverables[index - 1]
                                                .tasks[index1 - 1]
                                            ),
                                            trigger: "hover",
                                            placement: "bottom"
                                          },
                                          expression:
                                            "{ customClass: 'milestone--tooltip', html: true, title: tipTaskData(projectDeliverables[index - 1].tasks[index1 - 1]), trigger: 'hover', placement: 'bottom' }"
                                        }
                                      ],
                                      style: {
                                        backgroundColor: _vm.tryJSONParse(
                                          _vm.getFieldJson(
                                            _vm.projectDeliverables[index - 1]
                                              .tasks[index1 - 1].taskFields,
                                            "status"
                                          ).value
                                        ).color
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.scrollToTask(
                                            _vm.projectDeliverables[index - 1]
                                              .tasks[index1 - 1].id,
                                            index
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v(" ")]
                                  )
                                }
                              ),
                              0
                            )
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "dates" }, [
                      _c("span", { staticClass: "left" }, [
                        _vm._v(
                          _vm._s(
                            _vm._f("moment")(
                              _vm.projectDetail.start_date,
                              "MMMM DD, YYYY"
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "right" }, [
                        _vm._v(
                          _vm._s(
                            _vm._f("moment")(
                              _vm.projectDetail.due_date,
                              "MMMM DD, YYYY"
                            )
                          )
                        )
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._l(
                _vm._.filter(_vm.projectDetail.customFields, {
                  field_key: "project_detail"
                }),
                function(field, index) {
                  return _c(
                    "div",
                    {
                      key: "prj__detail__" + index,
                      staticClass: "field-box project--detail--field"
                    },
                    [
                      _c("ProjectCustomFields", {
                        attrs: {
                          deliverable: _vm.projectDetail,
                          customField: field
                        }
                      })
                    ],
                    1
                  )
                }
              ),
              _vm._v(" "),
              _c("div", { staticClass: "project--resources" }, [
                _c(
                  "div",
                  { staticClass: "dropdown project--resources--title" },
                  [
                    _c(
                      "button",
                      {
                        staticClass:
                          "add-resource-button exclude-outside-click d-inline-block",
                        attrs: {
                          title: "Add resource",
                          id: "add-resource-button",
                          "data-toggle": "dropdown",
                          "aria-expanded": "false"
                        }
                      },
                      [_vm._v("Resources")]
                    ),
                    _vm._v(" "),
                    _c("plus-button", {
                      attrs: {
                        "data-toggle": "dropdown",
                        "aria-expanded": "false",
                        "data-reference": "parent"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "dropdown-menu project--resources--type--menu"
                      },
                      _vm._l(_vm.optionsForLinkType, function(type, i) {
                        return _c(
                          "a",
                          {
                            key: i,
                            staticClass: "dropdown-item",
                            attrs: { href: "#" },
                            on: {
                              click: function($event) {
                                return _vm.addResourceMenuItemClick(
                                  type,
                                  $event
                                )
                              }
                            }
                          },
                          [
                            _c("img", {
                              staticClass: "link-type-icon",
                              attrs: {
                                src: require("@/csmworkflow/img/" + type.icon)
                              }
                            }),
                            _vm._v(" " + _vm._s(type.name))
                          ]
                        )
                      }),
                      0
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { class: _vm.getProjectResourcesClass },
                  _vm._l(
                    _vm._.filter(_vm.projectDetail.customFields, {
                      field_key: "link_url"
                    }),
                    function(resource, index) {
                      return _vm.showResourceBox(
                        resource.value,
                        resource.pfv_id
                      )
                        ? _c(
                            "div",
                            {
                              key: "link_url-" + index,
                              staticClass: "resource-entry resource-box",
                              class: _vm.userCanEditProject
                                ? "editable"
                                : "not-editable"
                            },
                            [
                              _c("img", {
                                staticClass: "link-type-icon",
                                attrs: {
                                  src: require("@/csmworkflow/img/" +
                                    _vm.getLinkTypeObject(
                                      _vm.customChildFieldValue(
                                        "link_type",
                                        resource.pfv_id
                                      )
                                    ).icon),
                                  draggable: "false"
                                }
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "resource-box__url" }),
                              _vm._v(" "),
                              resource.value
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "resource-link",
                                      attrs: {
                                        href: resource.value,
                                        target: "_blank",
                                        id: "project-resource-" + index
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.openCopyLinkModal(
                                            resource.value,
                                            $event,
                                            index
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.customChildFieldValue(
                                            "link_label",
                                            resource.pfv_id
                                          ) || resource.value
                                        )
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !resource.value
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "resource-link",
                                      attrs: {
                                        href: _vm.getResourceHref(
                                          resource.value,
                                          resource.pfv_id
                                        ),
                                        target: "_blank",
                                        id: "project-resource-" + index
                                      },
                                      on: { click: _vm.setCookieForDownload }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.customChildFieldValue(
                                            "link_label",
                                            resource.pfv_id
                                          ) || resource.value
                                        )
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "b-tooltip",
                                {
                                  attrs: {
                                    target: "project-resource-" + index,
                                    noninteractive: "",
                                    triggers: "manual"
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass: "fas fa-check",
                                    staticStyle: {
                                      color: "'var(--wf-primary)'"
                                    }
                                  }),
                                  _vm._v(" Link Copied!")
                                ]
                              ),
                              _vm._v(" "),
                              _vm.userCanEditProject
                                ? _c(
                                    "a",
                                    {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.hover",
                                          modifiers: { hover: true }
                                        }
                                      ],
                                      staticClass: "edit-resource-btn",
                                      attrs: {
                                        title: "Edit resource",
                                        href: "#"
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.editResource(resource)
                                        }
                                      }
                                    },
                                    [_c("i", { staticClass: "fas fa-edit" })]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.customChildFieldValue(
                                "link_notes",
                                resource.pfv_id
                              )
                                ? _c(
                                    "div",
                                    { staticClass: "resource-box__notes" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.customChildFieldValue(
                                              "link_notes",
                                              resource.pfv_id
                                            )
                                          )
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e()
                    }
                  ),
                  0
                )
              ])
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-4 right--side" }, [
            _c(
              "div",
              { staticClass: "project-right-side-fields" },
              [
                typeof _vm.projectDetail == "object" &&
                _vm.projectDetail.engagement_manager &&
                _vm.getSystemSetting("project__show_engagement_manager")
                  ? _c(
                      "div",
                      {
                        key:
                          "prjfields" +
                          _vm.projectDetail.id +
                          "-em-" +
                          _vm.projectDetail.engagement_manager.id +
                          "-wrapper",
                        staticClass: "field-box"
                      },
                      [
                        _c("ProjectCustomFields", {
                          key:
                            "prjfields" +
                            _vm.projectDetail.id +
                            "-em-" +
                            _vm.projectDetail.engagement_manager.id,
                          attrs: {
                            deliverable: _vm.projectDetail,
                            customField: {
                              field_key: "engagement_manager",
                              field_name: "engagement_manager",
                              label: "Engagement Manager"
                            }
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                typeof _vm.projectDetail == "object" &&
                _vm.projectDetail.engagement_manager &&
                _vm.getSystemSetting("project__show_engagement_manager") &&
                _vm.getSystemSetting("project__engagement_manager_lock")
                  ? _c(
                      "div",
                      {
                        staticClass: "project-engagement-manager-lock-wrapper"
                      },
                      [
                        _vm.projectDetail.engagement_manager_locked
                          ? _c(
                              "button",
                              {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.hover",
                                    modifiers: { hover: true }
                                  }
                                ],
                                staticClass: "btn btn-icon",
                                attrs: {
                                  title:
                                    "Unlock to automatically set the engagement manager when the department for the project changes."
                                },
                                on: {
                                  click:
                                    _vm.doToggleProjectEngagementManagerLock
                                }
                              },
                              [_c("i", { staticClass: "icomoon-lock-solid" })]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.projectDetail.engagement_manager_locked
                          ? _c(
                              "button",
                              {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.hover",
                                    modifiers: { hover: true }
                                  }
                                ],
                                staticClass: "btn btn-icon",
                                attrs: {
                                  title:
                                    "Lock to prevent the engagement manager from changing when the department for the project is changed"
                                },
                                on: {
                                  click:
                                    _vm.doToggleProjectEngagementManagerLock
                                }
                              },
                              [_c("i", { staticClass: "icomoon-unlock" })]
                            )
                          : _vm._e()
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                typeof _vm.projectDetail == "object" &&
                _vm.projectDetail.project_lead &&
                typeof _vm.projectDetail.project_leaders == "undefined"
                  ? _c(
                      "div",
                      { staticClass: "field-box" },
                      [
                        _c("ProjectCustomFields", {
                          key: "prjfields" + _vm.projectDetail.id,
                          attrs: {
                            deliverable: _vm.projectDetail,
                            customField: {
                              field_key: "project_lead",
                              field_name: "project_lead",
                              label:
                                _vm.getSystemSetting(
                                  "project__project_lead_label"
                                ) || "PROJECT LEAD"
                            }
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                typeof _vm.projectDetail == "object" &&
                typeof _vm.projectDetail.project_leaders != "undefined"
                  ? _c(
                      "div",
                      { staticClass: "field-box" },
                      [
                        _c("ProjectCustomFields", {
                          key: "prjfields" + _vm.projectDetail.id,
                          attrs: {
                            deliverable: _vm.projectDetail,
                            customField: {
                              field_key: "project_leaders",
                              field_name: "project_leaders",
                              label:
                                _vm.getSystemSetting(
                                  "project__project_lead_label"
                                ) || "PROJECT LEADERS"
                            }
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(
                  _vm._.filter(_vm.projectDetail.customFields, {
                    field_key: "project_status"
                  }),
                  function(field, index) {
                    return _c(
                      "div",
                      {
                        key: "prj__budget__" + Math.random(),
                        staticClass: "field-box"
                      },
                      [
                        _c("ProjectCustomFields", {
                          key: "prjfields" + _vm.projectDetail.id,
                          attrs: {
                            deliverable: _vm.projectDetail,
                            customField: field
                          }
                        })
                      ],
                      1
                    )
                  }
                ),
                _vm._v(" "),
                _vm._l(
                  _vm._.filter(_vm.projectDetail.customFields, {
                    field_key: "project_audience"
                  }),
                  function(field, index) {
                    return _c(
                      "div",
                      {
                        key: "prj__budget__" + Math.random(),
                        staticClass: "field-box"
                      },
                      [
                        _c("ProjectCustomFields", {
                          key: "prjfields" + _vm.projectDetail.id,
                          attrs: {
                            deliverable: _vm.projectDetail,
                            customField: field
                          }
                        })
                      ],
                      1
                    )
                  }
                ),
                _vm._v(" "),
                _vm._l(
                  _vm._.filter(_vm.projectDetail.customFields, {
                    field_key: "project_secondary_audience"
                  }),
                  function(field, index) {
                    return _c(
                      "div",
                      {
                        key: "prj__" + field.field_key + "__" + index,
                        staticClass: "field-box"
                      },
                      [
                        _c("ProjectCustomFields", {
                          key: "prjfields" + _vm.projectDetail.id,
                          attrs: {
                            deliverable: _vm.projectDetail,
                            customField: field
                          }
                        })
                      ],
                      1
                    )
                  }
                ),
                _vm._v(" "),
                _vm._l(
                  _vm._.filter(_vm.projectDetail.customFields, {
                    field_key: "account_number"
                  }),
                  function(field, index) {
                    return _c(
                      "div",
                      {
                        key: "prj__" + field.field_key + "__" + index,
                        staticClass: "field-box"
                      },
                      [
                        _c("ProjectCustomFields", {
                          key: "prjfields" + _vm.projectDetail.id,
                          attrs: {
                            deliverable: _vm.projectDetail,
                            customField: field
                          }
                        })
                      ],
                      1
                    )
                  }
                ),
                _vm._v(" "),
                _vm._l(
                  _vm._.filter(_vm.projectDetail.customFields, {
                    field_key: "budget"
                  }),
                  function(field, index) {
                    return _c(
                      "div",
                      {
                        key: "prj__budget__" + Math.random(),
                        staticClass: "field-box"
                      },
                      [
                        _c("ProjectCustomFields", {
                          key: "prjfields" + _vm.projectDetail.id,
                          attrs: {
                            deliverable: _vm.projectDetail,
                            customField: field
                          }
                        })
                      ],
                      1
                    )
                  }
                ),
                _vm._v(" "),
                _vm._l(
                  _vm._.filter(_vm.projectDetail.customFields, {
                    field_key: "requisition_number"
                  }),
                  function(field, index) {
                    return _vm.showProjectCustomField(
                      _vm.projectDetail,
                      "requisition_number"
                    )
                      ? _c(
                          "div",
                          {
                            key: "prj__requisition__number__" + index,
                            staticClass: "field-box"
                          },
                          [
                            _c("ProjectCustomFields", {
                              key: "prjfields" + _vm.projectDetail.id,
                              attrs: {
                                deliverable: _vm.projectDetail,
                                customField: field
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  }
                ),
                _vm._v(" "),
                _vm._l(
                  _vm._.filter(_vm.projectDetail.projectCustomFields, {
                    field_key: "manager_marketing_branding"
                  }),
                  function(field, index) {
                    return _c(
                      "div",
                      {
                        key: "prj__" + field.field_key + "__" + index,
                        staticClass: "field-box"
                      },
                      [
                        _c("ProjectCustomFields", {
                          key: "prjfields" + _vm.projectDetail.id,
                          attrs: {
                            deliverable: _vm.projectDetail,
                            customField: field
                          }
                        })
                      ],
                      1
                    )
                  }
                ),
                _vm._v(" "),
                _vm._l(
                  _vm._.filter(_vm.projectDetail.projectCustomFields, {
                    field_key: "marketing_officer"
                  }),
                  function(field, index) {
                    return _c(
                      "div",
                      {
                        key: "prj__" + field.field_key + "__" + index,
                        staticClass: "field-box"
                      },
                      [
                        _c("ProjectCustomFields", {
                          key: "prjfields" + _vm.projectDetail.id,
                          attrs: {
                            deliverable: _vm.projectDetail,
                            customField: field
                          }
                        })
                      ],
                      1
                    )
                  }
                ),
                _vm._v(" "),
                _vm._l(
                  _vm._.filter(_vm.projectDetail.projectCustomFields, {
                    field_key: "communications_officer"
                  }),
                  function(field, index) {
                    return _c(
                      "div",
                      {
                        key: "prj__" + field.field_key + "__" + index,
                        staticClass: "field-box"
                      },
                      [
                        _c("ProjectCustomFields", {
                          key: "prjfields" + _vm.projectDetail.id,
                          attrs: {
                            deliverable: _vm.projectDetail,
                            customField: field
                          }
                        })
                      ],
                      1
                    )
                  }
                ),
                _vm._v(" "),
                _vm.projectDetail.id &&
                (_vm.hasContactFields() ||
                  _vm.getSystemSetting("is_chat_enabled"))
                  ? _c(
                      "b-tabs",
                      {
                        staticClass: "field-tabs",
                        attrs: {
                          "content-class": "field-tab-content",
                          fill: ""
                        },
                        model: {
                          value: _vm.currentTab,
                          callback: function($$v) {
                            _vm.currentTab = $$v
                          },
                          expression: "currentTab"
                        }
                      },
                      [
                        _vm.hasContactFields()
                          ? _c(
                              "b-tab",
                              {
                                staticClass: "field-tab-contacts field-box",
                                attrs: { active: "", title: "Contact" }
                              },
                              [
                                _c("ProjectContact", {
                                  attrs: { projectDetail: _vm.projectDetail }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.getSystemSetting("is_chat_enabled")
                          ? _c(
                              "b-tab",
                              {
                                staticClass: "field-tab-chat",
                                attrs: {
                                  lazy: _vm.lazyLoadChat,
                                  title: "Chat"
                                },
                                on: { click: _vm.turnOffLazy }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "chat-wrapper" },
                                  [
                                    _c("Chat", {
                                      attrs: {
                                        primaryParticipantId:
                                          _vm.projectDetail.id,
                                        primaryParticipantTitle:
                                          _vm.projectDetail.title,
                                        primaryParticipantType: 0,
                                        chatNamespace: "projectChat",
                                        shouldRefreshMessages:
                                          _vm.currentTab == 1
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e()
              ],
              2
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "responsive-edit-modal-controls",
          class: {
            open: _vm.showModalOptions,
            "calendar-controls": _vm.$router.currentRoute.name == "calendar"
          }
        },
        [
          _vm.userCanEditProject
            ? _c(
                "button",
                {
                  directives: [
                    {
                      name: "b-tooltip",
                      rawName: "v-b-tooltip.hover",
                      modifiers: { hover: true }
                    }
                  ],
                  staticClass:
                    "btn delete-deliverable-btn duplicate-project-btn",
                  attrs: { title: "Duplicate Project" },
                  on: {
                    click: function($event) {
                      return _vm.duplicateProject()
                    }
                  }
                },
                [_c("i", { staticClass: "fas fa-copy" })]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.userCanEditProject
            ? _c(
                "button",
                {
                  directives: [
                    {
                      name: "b-tooltip",
                      rawName: "v-b-tooltip.hover",
                      modifiers: { hover: true }
                    }
                  ],
                  staticClass: "btn delete-deliverable-btn merge-project-btn",
                  attrs: { title: "Merge Project" },
                  on: {
                    click: function($event) {
                      return _vm.mergeProject()
                    }
                  }
                },
                [_c("i", { staticClass: "fas fa-code-merge" })]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.userCanEditProject
            ? _c(
                "button",
                {
                  directives: [
                    {
                      name: "b-tooltip",
                      rawName: "v-b-tooltip.hover",
                      modifiers: { hover: true }
                    }
                  ],
                  staticClass: "btn delete-deliverable-btn",
                  attrs: { title: "Delete Project" },
                  on: {
                    click: function($event) {
                      return _vm.removeProject()
                    }
                  }
                },
                [_c("i", { staticClass: "fas fa-trash-alt" })]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.$router.currentRoute.name == "calendar"
            ? _c(
                "button",
                {
                  directives: [
                    {
                      name: "b-tooltip",
                      rawName: "v-b-tooltip.hover",
                      modifiers: { hover: true }
                    }
                  ],
                  staticClass: "btn close-deliverable-btn",
                  attrs: { title: "Close" },
                  on: { click: _vm.onCloseModal }
                },
                [_c("i", { staticClass: "fas fa-times" })]
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "duplicateProjectModal",
            size: "lg",
            title:
              _vm.duplicateStatus === "completed"
                ? "Duplication Complete"
                : "Duplicate Project",
            "ok-title":
              _vm.duplicateStatus === "completed" ? "View Project" : "Duplicate"
          },
          on: { ok: _vm.onDuplicateProject },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function(ref) {
                var ok = ref.ok
                var cancel = ref.cancel
                return [
                  _vm.duplicateStatus !== "processing"
                    ? _c(
                        "b-button",
                        {
                          on: {
                            click: function($event) {
                              return cancel()
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                _vm.duplicateStatus === "completed"
                                  ? "Close"
                                  : "Cancel"
                              ) +
                              "\n      "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: {
                        variant: "success",
                        disabled:
                          _vm.duplicateStatus === "processing" ||
                          _vm.duplicateStatus === "failed" ||
                          (_vm.duplicateStatus === "completed" &&
                            !_vm.duplicateProjectNumber) ||
                          (!_vm.duplicateStatus &&
                            (_vm.duplicateNameExists ||
                              !_vm.duplicateOptions.readyToDuplicate))
                      },
                      on: {
                        click: function($event) {
                          return ok()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.duplicateStatus === "completed"
                              ? "View Project"
                              : "Duplicate"
                          ) +
                          "\n      "
                      )
                    ]
                  )
                ]
              }
            }
          ]),
          model: {
            value: _vm.showDuplicateProject,
            callback: function($$v) {
              _vm.showDuplicateProject = $$v
            },
            expression: "showDuplicateProject"
          }
        },
        [
          _vm.duplicateBeforeTotal > 0
            ? _c("div", { staticClass: "text-center" }, [
                _c("p", { staticClass: "mt-3 duplicate-progress-count" }, [
                  _vm._v(_vm._s(_vm.duplicateMessage))
                ])
              ])
            : _vm.duplicateStatus === "processing" ||
              _vm.duplicateStatus === "pending"
            ? _c(
                "div",
                { staticClass: "text-center" },
                [
                  _c("b-progress", {
                    staticClass: "mb-3 duplicate-progress-bar",
                    attrs: { value: _vm.duplicateProgress, height: "20px" }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "duplicate-progress-message" }, [
                    _vm.duplicateProgressCount
                      ? _c(
                          "span",
                          { staticClass: "duplicate-progress-count" },
                          [_vm._v(_vm._s(_vm.duplicateProgressCount))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("span", { staticClass: "duplicate-progress-text" }, [
                      _vm._v(_vm._s(_vm.duplicateMessage))
                    ]),
                    _vm._v(" "),
                    _vm.duplicateProgressLabel
                      ? _c(
                          "span",
                          { staticClass: "duplicate-progress-label" },
                          [_vm._v(_vm._s(_vm.duplicateProgressLabel))]
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _vm.duplicateStatus === "pending"
                    ? _c("p", { staticClass: "text-muted" }, [
                        _c("small", [
                          _vm._v(
                            "Another project is being duplicated. Your request will begin shortly."
                          )
                        ])
                      ])
                    : _vm._e()
                ],
                1
              )
            : _vm.duplicateStatus === "completed"
            ? _c("div", { staticClass: "text-center" }, [
                _c("i", {
                  staticClass: "fas fa-check-circle text-success",
                  staticStyle: { "font-size": "3rem" }
                }),
                _vm._v(" "),
                _c("p", { staticClass: "mt-3 duplicate-progress-message" }, [
                  _vm._v(_vm._s(_vm.duplicateMessage))
                ])
              ])
            : _vm.duplicateStatus === "failed"
            ? _c("div", { staticClass: "text-center" }, [
                _c("i", {
                  staticClass: "fas fa-times-circle text-danger",
                  staticStyle: { "font-size": "3rem" }
                }),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    staticClass: "mt-3",
                    staticStyle: { "font-weight": "bold" }
                  },
                  [_vm._v("A system error occurred. Duplication failed.")]
                ),
                _vm._v(" "),
                _c("p", { staticClass: "text-muted" }, [
                  _vm._v(
                    "\n        An error notification has been sent to Pattern Interactive.\n      "
                  )
                ])
              ])
            : _c(
                "div",
                [
                  _c(
                    "b-form",
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass: "mb-4",
                          attrs: {
                            label: "New Project Name",
                            "label-class": "font-weight-500",
                            "label-for": "newProjectTitle"
                          }
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "newProjectTitle",
                              state: _vm.duplicateNameExists ? false : null
                            },
                            on: { input: _vm.checkDuplicateName },
                            model: {
                              value: _vm.duplicateOptions.title,
                              callback: function($$v) {
                                _vm.$set(_vm.duplicateOptions, "title", $$v)
                              },
                              expression: "duplicateOptions.title"
                            }
                          }),
                          _vm._v(" "),
                          _vm.duplicateNameExists
                            ? _c("b-form-invalid-feedback", [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      !_vm.duplicateOptions.title.trim()
                                        ? "Project name is required"
                                        : "A project with this name already exists"
                                    ) +
                                    "\n          "
                                )
                              ])
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        {
                          staticClass: "mb-4",
                          attrs: {
                            label: "Duplication Options",
                            "label-class": "font-weight-500"
                          }
                        },
                        [
                          _c("div", { staticClass: "mb-4" }, [
                            _c("h6", { staticClass: "text-muted mb-3" }, [
                              _vm._v("Project")
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "ml-3" },
                              [
                                _c(
                                  "b-form-checkbox",
                                  {
                                    model: {
                                      value: _vm.duplicateOptions.department,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.duplicateOptions,
                                          "department",
                                          $$v
                                        )
                                      },
                                      expression: "duplicateOptions.department"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                Department\n              "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-checkbox",
                                  {
                                    model: {
                                      value: _vm.duplicateOptions.deadline,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.duplicateOptions,
                                          "deadline",
                                          $$v
                                        )
                                      },
                                      expression: "duplicateOptions.deadline"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                Deadline\n              "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-checkbox",
                                  {
                                    model: {
                                      value: _vm.duplicateOptions.projectDetail,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.duplicateOptions,
                                          "projectDetail",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "duplicateOptions.projectDetail"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                Project Detail\n              "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-checkbox",
                                  {
                                    model: {
                                      value: _vm.duplicateOptions.resources,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.duplicateOptions,
                                          "resources",
                                          $$v
                                        )
                                      },
                                      expression: "duplicateOptions.resources"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                Resources\n              "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-checkbox",
                                  {
                                    model: {
                                      value:
                                        _vm.duplicateOptions.engagementManager,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.duplicateOptions,
                                          "engagementManager",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "duplicateOptions.engagementManager"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                Engagement Manager\n              "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-checkbox",
                                  {
                                    model: {
                                      value: _vm.duplicateOptions.projectLead,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.duplicateOptions,
                                          "projectLead",
                                          $$v
                                        )
                                      },
                                      expression: "duplicateOptions.projectLead"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                Project Lead\n              "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-checkbox",
                                  {
                                    model: {
                                      value: _vm.duplicateOptions.status,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.duplicateOptions,
                                          "status",
                                          $$v
                                        )
                                      },
                                      expression: "duplicateOptions.status"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                Status\n              "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-checkbox",
                                  {
                                    model: {
                                      value: _vm.duplicateOptions.audience,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.duplicateOptions,
                                          "audience",
                                          $$v
                                        )
                                      },
                                      expression: "duplicateOptions.audience"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                Audience\n              "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-checkbox",
                                  {
                                    model: {
                                      value: _vm.duplicateOptions.budget,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.duplicateOptions,
                                          "budget",
                                          $$v
                                        )
                                      },
                                      expression: "duplicateOptions.budget"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                Budget\n              "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-checkbox",
                                  {
                                    model: {
                                      value:
                                        _vm.duplicateOptions.requisitionNumber,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.duplicateOptions,
                                          "requisitionNumber",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "duplicateOptions.requisitionNumber"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                Requisition number\n              "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "mb-4" }, [
                            _c("h6", { staticClass: "text-muted mb-3" }, [
                              _vm._v("Deliverables")
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "ml-3" },
                              [
                                _c(
                                  "b-form-checkbox",
                                  {
                                    attrs: {
                                      disabled: _vm.deliverableCount === 0
                                    },
                                    model: {
                                      value: _vm.duplicateOptions.deliverables,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.duplicateOptions,
                                          "deliverables",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "duplicateOptions.deliverables"
                                    }
                                  },
                                  [
                                    _vm._v("\n              \tCopy "),
                                    _vm.deliverableCount == 1
                                      ? [
                                          _vm._v(
                                            "\n              \t" +
                                              _vm._s(
                                                _vm.projectDeliverables.length
                                              ) +
                                              " Deliverable"
                                          )
                                        ]
                                      : [
                                          _vm._v(
                                            _vm._s(_vm.deliverableCount) +
                                              " Deliverables"
                                          )
                                        ],
                                    _c("br"),
                                    _vm._v(
                                      "(does not include media calls or social media posts)\n              "
                                    )
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-checkbox",
                                  {
                                    attrs: {
                                      disabled:
                                        !_vm.duplicateOptions.deliverables ||
                                        (_vm.projectDeliverables
                                          ? _vm.projectDeliverables.length
                                          : 0) === 0
                                    },
                                    model: {
                                      value:
                                        _vm.duplicateOptions.socialMediaPosts,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.duplicateOptions,
                                          "socialMediaPosts",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "duplicateOptions.socialMediaPosts"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                Include Social Media Posts\n              "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                false
                                  ? _c(
                                      "b-form-checkbox",
                                      {
                                        attrs: {
                                          disabled:
                                            !_vm.duplicateOptions
                                              .deliverables ||
                                            (_vm.projectDeliverables
                                              ? _vm.projectDeliverables.length
                                              : 0) === 0
                                        },
                                        model: {
                                          value:
                                            _vm.duplicateOptions
                                              .deliverableDueDates,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.duplicateOptions,
                                              "deliverableDueDates",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "duplicateOptions.deliverableDueDates"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                Copy Deliverable Due Dates\n              "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "b-form-checkbox",
                                  {
                                    attrs: {
                                      disabled:
                                        !_vm.duplicateOptions.deliverables ||
                                        (_vm.projectDeliverables
                                          ? _vm.projectDeliverables.length
                                          : 0) === 0
                                    },
                                    model: {
                                      value: _vm.duplicateOptions.taskUsers,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.duplicateOptions,
                                          "taskUsers",
                                          $$v
                                        )
                                      },
                                      expression: "duplicateOptions.taskUsers"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                Copy Task Users\n              "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                false
                                  ? _c(
                                      "b-form-checkbox",
                                      {
                                        attrs: {
                                          disabled:
                                            !_vm.duplicateOptions
                                              .deliverables ||
                                            (_vm.projectDeliverables
                                              ? _vm.projectDeliverables.length
                                              : 0) === 0
                                        },
                                        model: {
                                          value:
                                            _vm.duplicateOptions.taskDueDates,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.duplicateOptions,
                                              "taskDueDates",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "duplicateOptions.taskDueDates"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                Copy Task Due Dates\n              "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "b-form-checkbox",
                                  {
                                    attrs: {
                                      disabled:
                                        !_vm.duplicateOptions.deliverables ||
                                        (_vm.projectDeliverables
                                          ? _vm.projectDeliverables.length
                                          : 0) === 0
                                    },
                                    model: {
                                      value: _vm.duplicateOptions.taskNotes,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.duplicateOptions,
                                          "taskNotes",
                                          $$v
                                        )
                                      },
                                      expression: "duplicateOptions.taskNotes"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                Copy Task Notes\n              "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "pt-3 border-top",
                              staticStyle: { "margin-bottom": "-1em" }
                            },
                            [
                              _vm.projectDetail
                                ? _c(
                                    "b-form-checkbox",
                                    {
                                      staticClass: "font-weight-bold",
                                      model: {
                                        value:
                                          _vm.duplicateOptions.readyToDuplicate,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.duplicateOptions,
                                            "readyToDuplicate",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "duplicateOptions.readyToDuplicate"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n              I am ready to duplicate project '" +
                                          _vm._s(_vm.projectDetail.title) +
                                          "'\n            "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "mergeProjectModal",
            title: _vm.mergeSuccess ? "Merge Successful" : "Merge Project",
            "ok-title": _vm.mergeSuccess ? "Go Now" : "Merge"
          },
          on: { ok: _vm.onMergeProject },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function(ref) {
                var ok = ref.ok
                var cancel = ref.cancel
                return [
                  _c(
                    "b-button",
                    {
                      on: {
                        click: function($event) {
                          return cancel()
                        }
                      }
                    },
                    [_vm._v("\n        Cancel\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: {
                        variant: "success",
                        disabled:
                          (!_vm.mergeSuccess && !_vm.targetMergeProject.id) ||
                          _vm.mergeLoading
                      },
                      on: {
                        click: function($event) {
                          return ok()
                        }
                      }
                    },
                    [
                      _vm.mergeLoading
                        ? _c("b-spinner", { attrs: { small: "" } })
                        : _vm._e(),
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.mergeLoading
                              ? "Merging..."
                              : _vm.mergeSuccess
                              ? "Go Now"
                              : "Merge"
                          ) +
                          "\n      "
                      )
                    ],
                    1
                  )
                ]
              }
            }
          ]),
          model: {
            value: _vm.showMergeProject,
            callback: function($$v) {
              _vm.showMergeProject = $$v
            },
            expression: "showMergeProject"
          }
        },
        [
          !_vm.mergeSuccess && !_vm.mergeLoading
            ? _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", [_vm._v("Select project to merge into")]),
                  _vm._v(" "),
                  false
                    ? _c("multiselect", {
                        attrs: {
                          options: _vm.projectsOption,
                          label: "name",
                          "track-by": "id",
                          "allow-empty": false,
                          "show-labels": true,
                          placeholder: "Pick a project",
                          "aria-label": "pick a project"
                        },
                        model: {
                          value: _vm.targetMergeProject,
                          callback: function($$v) {
                            _vm.targetMergeProject = $$v
                          },
                          expression: "targetMergeProject"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("multiselect", {
                    ref: "deliverableProjects",
                    attrs: {
                      "close-on-select": true,
                      options: _vm.projectsOption,
                      "show-labels": true,
                      multiple: false,
                      taggable: false,
                      label: "name",
                      "track-by": "id",
                      "allow-empty": false,
                      "group-label": "group",
                      "group-values": "entries",
                      "group-select": false,
                      placeholder: "Pick a project",
                      "aria-label": "pick a project"
                    },
                    on: {
                      input: function($event) {
                        return _vm.onProjectSelected(_vm.targetMergeProject)
                      }
                    },
                    model: {
                      value: _vm.targetMergeProject,
                      callback: function($$v) {
                        _vm.targetMergeProject = $$v
                      },
                      expression: "targetMergeProject"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.mergeLoading
            ? _c(
                "div",
                { staticClass: "text-center" },
                [
                  _c("b-spinner", {
                    staticStyle: { width: "3rem", height: "3rem" },
                    attrs: { variant: "primary" }
                  }),
                  _vm._v(" "),
                  _c("p", { staticClass: "mt-3" }, [
                    _vm._v("Merging projects...")
                  ])
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.mergeSuccess
            ? _c("div", { staticClass: "text-center" }, [
                _c("i", {
                  staticClass: "fas fa-check-circle text-success",
                  staticStyle: { "font-size": "3rem" }
                }),
                _vm._v(" "),
                _c("p", { staticClass: "mt-3" }, [
                  _vm._v("Projects merged successfully!")
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v("Redirecting to project page in "),
                  _c("strong", [_vm._v(_vm._s(_vm.mergeCountdown))]),
                  _vm._v(" seconds...")
                ])
              ])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            type: "warn",
            title: "Confirm Deletion",
            "ok-title": "Yes, Delete"
          },
          on: { ok: _vm.onConfirmRemoveProject },
          model: {
            value: _vm.showRemoveProject,
            callback: function($$v) {
              _vm.showRemoveProject = $$v
            },
            expression: "showRemoveProject"
          }
        },
        [_c("p", [_vm._v("Are you sure you want to delete this project?")])]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            centered: "",
            "no-close-on-backdrop": "",
            "hide-footer": "",
            id: "createProjectLinkModal",
            title: "New Resource / Link"
          },
          on: { shown: _vm.focusLinkModal }
        },
        [
          _c("CreateProjectLinkModal", {
            ref: "refLinkModal",
            attrs: {
              "link-url": _vm.linkUrl,
              "link-label": _vm.linkLabel,
              "link-notes": _vm.linkNotes,
              "link-type": _vm.linkType,
              "is-file": _vm.editLinkIsFile,
              "resource-parent": "project"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            centered: "",
            "no-close-on-backdrop": "",
            "hide-footer": "",
            id: "editProjectLinkModal",
            title: "Update Resource / Link"
          },
          on: { shown: _vm.focusEditLinkModal }
        },
        [
          _c("EditProjectLinkModal", {
            ref: "refEditLinkModal",
            attrs: {
              "link-url": _vm.linkUrl,
              "link-label": _vm.linkLabel,
              "link-notes": _vm.linkNotes,
              "link-type": _vm.linkType,
              "is-file": _vm.editLinkIsFile
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            centered: "",
            id: "linkCopyLinkModal",
            title: "Copy Link",
            "ok-only": "",
            "ok-title": "Done"
          }
        },
        [
          _c("LinkCopyLinkModal", {
            attrs: { linkUrl: _vm.linkCopyModalValue }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }